export const LOGO_IMAGE = "/images/logo.png";

export const HERO_IMAGE = "/images/hero.jpg";
export const HERO_IMAGE_2 = "/images/hero-2.jpg";
export const HERO_IMAGE_3 = "/images/hero-3.jpg";

export const HERO_SLIDE_IMAGES = [HERO_IMAGE, HERO_IMAGE_2, HERO_IMAGE_3];
export const HERO_SLIDE_COUNT = HERO_SLIDE_IMAGES.length;

export const ABOUT_HOME_IMAGE = "/images/about-home.jpg";
